import { useEffect, useMemo, useState } from "react";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FerramentasDeDetalhe, SelectComponent } from "../../shered/components";
import { VForm, useVForm } from "../../shered/forms";
import { LayoutBaseDePagina } from "../../shered/layouts";
import {
    Box, Paper, Typography, useTheme,
    Autocomplete,
    CircularProgress,
    TextField,
    Button,
    Icon,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { DataGrid, GridColDef, GridEventListener } from "@mui/x-data-grid";
import { ptBR } from '@mui/x-data-grid/locales';
import { FranquiaService, IDetalheFranquia, IListagemJogadoresDisponiveis, ILstDrop } from "../../shered/services/api/franquia/FranquiaService";
import { IListagemJogador, JogadorService } from "../../shered/services/api/jogador/JogadorService";
import { Loading } from "../../shered/components/loading/Loading";
import { TDropOptions, UtilidadeService, lstReferenciasPosicao, lstPosicaoAmericano, tipoDisponibilizacaoJogador } from "../../shered/services/api/utilidades/UtilidadesService";
import { DraftService } from "../../shered/services/api/draft/DraftService";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import { TDropOptionsJogador } from "../escalacao/DetalheDeEscalacao";
import { IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { VTextMaskCustom } from "../../shered/forms/VTextMaskCustom";

export const ListagemDeJogadoresDisponiveis: React.FC = () => {
    const theme = useTheme();
    const { formRef, save } = useVForm();
    const { themeName } = useAppThemeContext();
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, logout } = useAuthContext();
    const [edicao, setEdicao] = useState(false);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [opcoesAutoCompleteJogador, setOpcoesAutoCompleteJogador] = useState<TDropOptions[]>([])
    const [listaTodosJogadores, setListaTodosJogadores] = useState<TDropOptionsJogador[]>([])
    const [selectedIdComplete, setSelectedIdComplete] = useState<number | undefined>(0);
    const [rowsJogadores, setRowsJogadores] = useState<IListagemJogadoresDisponiveis[]>([]);
    const [franquiaSelecionada, setFranquiaSelecionada] = useState(0);
    const [posicaoSelecionada, setPosicaoSelecionada] = useState(0);
    const [codigoFranquia, setCodigoFranquia] = useState(0);
    const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
    const [lstFranquias, setLstFranquias] = useState<ILstDrop[]>([]);
    const [pedida, setPedida] = useState(0);
    const [salarioMaximo, setSalarioMaximo] = useState("0");
    const [searchParamsJogadores, SetSearchParams] = useSearchParams();
    const [redirecionar, setRedirecionar] = useState("0");
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [lstPosicao, setLstPosicao] = useState<ILstDrop[]>([]);
    const [dadosModal, setDadosModal] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const options: Intl.NumberFormatOptions = { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 3 }
    const formatNumber = new Intl.NumberFormat('pt-BR', options);

    const columnsJogadores: GridColDef[] = [
        {
            field: 'codigo_Jogador',
            headerName: 'CÓDIGO',
            flex: 1,
            minWidth: 75,
            //width: 90,
            headerClassName: 'super-app-theme--header',
            headerAlign: "center",
            align: "center"
        },
        {
            field: 'foto_Jogador',
            headerName: 'FOTO',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 90 : 110,
            sortable: false,
            //width: 90,
            renderCell: (params) => (params.value !== null && params.value !== "" && params.value !== undefined)
                ? <img src={params.value} width={UtilidadeService.isMobile() ? 45 : 50} height={UtilidadeService.isMobile() ? 45 : 50}
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = "../../../../semimagem.png";
                        currentTarget.style.borderRadius = "50%";
                        currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                        currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
                    }}
                />
                : <img src={"../../../../semimagem.png"} width={UtilidadeService.isMobile() ? 30 : 40} height={UtilidadeService.isMobile() ? 30 : 40} style={{ borderRadius: "50%" }} />,
            headerClassName: 'super-app-theme--header',
            headerAlign: "center",
            align: "center"
        },
        {
            field: 'nome_Jogador',
            headerName: 'JOGADOR',
            description: 'Nome do Jogador da Franquia escolhido',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 110 : 190,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
            //valueGetter: (params: GridValueGetterParams) =>`${params.row.nome_Jogador_Escolhido || ''}`,
        },
        {
            field: 'posicao',
            headerName: 'POSIÇÃO',
            sortable: false,
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 110 : 130,
            headerClassName: 'super-app-theme--header',
            align: "center",
            headerAlign: "center",
            renderCell: (params) => (carregaPosicao(params.row.posicao_Jogador_1, params.row.posicao_Jogador_2, params.row.posicao_Jogador_3))
        },
        {
            field: 'nome_Franquia',
            headerName: 'FRANQUIA',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 110 : 130,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
        {
            field: 'salario_Jogador',
            headerName: 'SALÁRIO / ANO',
            flex: 1,
            minWidth: 160,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (`${formatNumber.format(Number(params.value.toString()))} / ${params.row.tempo_Contrato_Jogador === 0 ? "Direitos" : params.row.tempo_Contrato_Jogador} `)
        },
        {
            field: 'codigo_Tipo_Ativo_Troca',
            headerName: 'PEDIDA',
            flex: 1,
            sortable: false,
            minWidth: 100,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >{
                            (params.value !== null && params.value !== "" && params.value !== undefined) ?
                                tipoDisponibilizacaoJogador.find(f => f.codigo === params.value)?.label
                                :
                                ""
                        }
                    </Box >
                );
            },
        }
    ];

    const autoCompleteSelectedOption = useMemo(() => {
        if (!selectedIdComplete) return null;

        const selectedOption = opcoesAutoCompleteJogador.find(opcao => opcao.codigo === selectedIdComplete);
        if (!selectedOption) return null;

        return selectedOption;
    }, [selectedIdComplete, opcoesAutoCompleteJogador]);

    const paginaJogadores = useMemo(() => {
        return Number(searchParamsJogadores.get("pagina") || "1");
    }, [searchParamsJogadores]);


    useEffect(() => {
        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });

            setRedirecionar("/dashboard");
            return;
        }
        setIsLoading(true);
        const fetchData = async () => {
            setIsLoading(false);
            await LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
                .then((result) => {
                    setIsLoading(false);
                    const liga = result.dado;
                    setDadosLiga(liga);
                    setCodigoFranquia(liga.codigo_Franquia);
                    const lstPosicaoLiga = liga.codigo_Tipo_Posicao_Confronto !== 2 ?lstReferenciasPosicao : lstPosicaoAmericano;
                    setLstPosicao(lstPosicaoLiga);
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                });

            await FranquiaService.getTodosJogadoresDisponiveis(1, '', Number(codigoLiga), null, null, null, null, null)
                .then(result => {
                    setRowsJogadores(result.dado);
                    const lstDrop: TDropOptions[] = result.dado.sort((a, b) => a.nome_Jogador > b.nome_Jogador ? 1 : -1)
                        .map((f, i) => ({ codigo: f.codigo_Jogador, label: f.nome_Jogador, descricao: "" }));
                    setOpcoesAutoCompleteJogador(lstDrop);
                }).catch((errors) => {
                    setIsLoading(false);
                    setShowModalMensagem(true);
                    if (errors.response.data.statusHTTP === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Sessão Expirada! 1",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    if (errors.response.data.mensagem !== undefined) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                    }
                    else {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Não foi possível carregar os dados dos jodadores! Favor entrar em contato com a TI",
                            display: "none",
                            titulo: "Atenção"
                        });
                    }
                });
            await FranquiaService.getByIdLiga(Number(codigoLiga)).then(result => {
                let lstFranquia = result.dado.map((f, i) => ({ codigo: f.codigo, label: f.nome === null ? `Franquia ${i + 1} ` : f.nome }));
                setLstFranquias(lstFranquia);
            }).catch((errors) => {
                setRemoveLoading(true);
                setIsLoading(false);
                setShowModalMensagem(true);
                if (errors.response.data.statusHTTP === 401) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Sessão Expirada! 2",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                if (errors.response.data.mensagem !== undefined) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                }
                else {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os dados da franquia! Favor entrar em contato com a TI",
                        display: "none",
                        titulo: "Atenção"
                    });
                }
            });
        }
        fetchData();
        setRemoveLoading(true);
    }, [paginaJogadores, codigoLiga]);

    const handleSave = async (dados: IDetalheFranquia) => {
        setIsLoading(true);
        setIsLoading(false);
    };


    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
    };

    const MyCustomNoRowsOverlay = () => (
        <Grid container size={{ xs: 12, sm: 12 }} paddingTop={2} display="flex" justifyContent="center" textAlign="center"  >
            {!removeLoading ? <Loading />
                : <Typography>Sem Registro(s)</Typography>
            }
        </Grid>
    );

    const handleFiltrarJogadores = async () => {

        const jogadorFiltro = autoCompleteSelectedOption?.codigo !== undefined ? autoCompleteSelectedOption?.codigo : null;
        //const posicaoSelecionadaFiltro = posicaoSelecionada !== null && posicaoSelecionada !== 0 ? lstReferenciasPosicao.find(f => f.codigo === posicaoSelecionada)?.label : null;
        const posicaoSelecionadaFiltro = posicaoSelecionada !== null && posicaoSelecionada !== 0 ? lstPosicao.find(f => f.codigo === posicaoSelecionada)?.label : null;
        const franquiaSelecionadaFiltro = franquiaSelecionada !== null ? franquiaSelecionada : null;
        const salarioMaximoFiltro = salarioMaximo !== null && salarioMaximo !== "0" ? salarioMaximo : null;
        const pedidaFiltro = pedida !== null ? pedida : null;

        await FranquiaService.getTodosJogadoresDisponiveis(1, ''
            , Number(codigoLiga)
            , jogadorFiltro
            , posicaoSelecionadaFiltro
            , franquiaSelecionadaFiltro
            , salarioMaximoFiltro
            , pedidaFiltro)
            .then(result => {
                setRowsJogadores(result.dado);
            }).catch((errors) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                if (errors.response.data.statusHTTP === 401) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Sessão Expirada! 1",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                if (errors.response.data.mensagem !== undefined) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                }
                else {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os dados dos jodadores! Favor entrar em contato com a TI",
                        display: "none",
                        titulo: "Atenção"
                    });
                }
            });
    }

    const carregaPosicao = (posicao_1: string, posicao_2: string | null, posicao_3: string | null) => {
        let posicoes = `${UtilidadeService.verificaTipoPosicao(posicao_1)} ${posicao_2 !== null ? " | " : ""} ${posicao_2 !== null ? UtilidadeService.verificaTipoPosicao(posicao_2) : ""} ${posicao_3 !== null ? " | " : ""} ${posicao_3 !== null ? UtilidadeService.verificaTipoPosicao(posicao_3) : ""}`;
        let qtd = posicoes.split("|").length;
        let arrImagens = posicoes.split("|");
        let imgs = qtd === 1 ?
            <img src={arrImagens[0]} alt={"img1"} width={UtilidadeService.isMobile() ? 20 : 25} height={UtilidadeService.isMobile() ? 20 : 25} style={{ borderRadius: "50%" }}
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = "../../../../semimagem.png";
                    currentTarget.style.borderRadius = "50%";
                    currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                    currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
                }}
            />
            : qtd === 2 ?
                <>  <img src={arrImagens[0]} alt={"img1"} width={UtilidadeService.isMobile() ? 20 : 25} height={UtilidadeService.isMobile() ? 20 : 25} style={{ borderRadius: "50%" }} />
                    <img src={arrImagens[1]} alt={"img2"} width={UtilidadeService.isMobile() ? 20 : 25} height={UtilidadeService.isMobile() ? 20 : 25} style={{ borderRadius: "50%", marginLeft: 4 }} />
                </>
                : <> <img src={arrImagens[0]} alt={"img1"} width={UtilidadeService.isMobile() ? 20 : 25} height={UtilidadeService.isMobile() ? 20 : 25} style={{ borderRadius: "50%" }} />
                    <img src={arrImagens[1]} alt={"img2"} width={UtilidadeService.isMobile() ? 20 : 25} height={UtilidadeService.isMobile() ? 20 : 25} style={{ borderRadius: "50%", marginLeft: 4 }} />
                    <img src={arrImagens[2]} alt={"img3"} width={UtilidadeService.isMobile() ? 20 : 25} height={UtilidadeService.isMobile() ? 20 : 25} style={{ borderRadius: "50%", marginLeft: 4 }} />
                </>
        return imgs
    }

    return (
        <LayoutBaseDePagina
            titulo={`Jogadores Disponíveis - Liga: ${dadosLiga?.nome}`}
            barraDeFerramentas={
                <FerramentasDeDetalhe
                    mostrarBotaoApagar={false}
                    mostrarBotaoSalvarEFechar={false}
                    mostrarBotaoSalvar={false}
                    mostrarBotaoNovo={false}
                    aoClicarEmSalvar={save}
                    aoClicarEmVoltar={() => navigate("/dashboard")}
                />
            }
        >
            {showModalMensagem && <DialogMensagem dados={dadosModal} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <VForm ref={formRef} onSubmit={handleSave}>
                <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                    <Grid container direction="column" padding={2} spacing={2}>
                        <Grid size={{ xs: 12, sm: 12 }} >
                            <Typography variant="h6">Filtros</Typography>
                            <hr />
                        </Grid>
                        <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="initial" spacing={3}>
                            <Grid size={{ xs: 12, sm: 2, md: 2 }} paddingBottom={UtilidadeService.isMobile() ? 1 : 2}>
                                <Autocomplete
                                    openText="Abrir"
                                    closeText="Fechar"
                                    noOptionsText="Sem opções"
                                    loadingText="Carregando..."
                                    disableCloseOnSelect
                                    options={opcoesAutoCompleteJogador}
                                    loading={isLoading}
                                    disabled={isLoading}
                                    size={UtilidadeService.isMobile() ? "small" : "medium"}
                                    value={autoCompleteSelectedOption}
                                    onChange={(event, newValue) => { setSelectedIdComplete(newValue?.codigo); }}
                                    popupIcon={isLoading ? <CircularProgress size={UtilidadeService.isMobile() ? 16 : 28} /> : undefined}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Jogador"
                                            slotProps={{                                              
                                                inputLabel: {
                                                    shrink: edicao ? true : undefined,
                                                    style: {
                                                        fontSize: UtilidadeService.isMobile() ? 12 : 14
                                                    }
                                                }                                                
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid size={{ xs: 6, sm: 2, md: 2 }} >
                                <SelectComponent
                                    required
                                    isExternalLoading={isLoading || edicao}
                                    label="Posição"
                                    name="posicao"
                                    //items={lstReferenciasPosicao}
                                    items={lstPosicao}
                                    variant="outlined"
                                    value={posicaoSelecionada}
                                    onChange={(e) => setPosicaoSelecionada(Number(e.target.value))}
                                    style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, height: UtilidadeService.isMobile() ? 35 : "auto" }}
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 2, md: 2 }} >
                                <VTextMaskCustom
                                    fullWidth
                                    size={UtilidadeService.isMobile() ? "small" : "medium"}
                                    name="salarioMaximo"
                                    type="text"
                                    disabled={isLoading}
                                    label="Salário Máximo"
                                    value={salarioMaximo}
                                    onChange={e => setSalarioMaximo(e.target.value)}
                                    typeMask="currency"
                                    slotProps={{
                                        inputLabel: {
                                            shrink: edicao ? true : undefined,
                                        }
                                    }}                                  
                                onFocus={(e) => e.target.select()}
                                />
                            </Grid>
                            <Grid size={{ xs: 6, sm: 2, md: 2 }} >
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Franquia</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label="Franquia"
                                        value={franquiaSelecionada}
                                        onChange={(e) => setFranquiaSelecionada(Number(e.target.value))}
                                        defaultValue={0}
                                        style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, height: UtilidadeService.isMobile() ? 35 : "auto" }}

                                    >
                                        <MenuItem key="0" value={0}>Selecione...</MenuItem>
                                        {
                                            lstFranquias.map(qtd =>
                                                <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                                            )
                                        }
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Tipo</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label="Tipo"
                                        value={pedida}
                                        onChange={(e) => setPedida(Number(e.target.value))}
                                        defaultValue={0}
                                        style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, height: UtilidadeService.isMobile() ? 35 : "auto" }}
                                    >
                                        <MenuItem key="0" value={0}>Selecione...</MenuItem>
                                        {
                                            tipoDisponibilizacaoJogador.map(qtd =>
                                                <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                                            )
                                        }
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 2, md: 2 }} display="flex" alignItems="start" justifyContent="start" >
                                <Button
                                    color="primary"
                                    variant="contained"
                                    disableElevation
                                    onClick={handleFiltrarJogadores}
                                    endIcon={<Icon style={{ fontSize: UtilidadeService.isMobile() ? 13 : 14 }} >search</Icon>}
                                    style={{ fontSize: UtilidadeService.isMobile() ? 13 : 14, height: UtilidadeService.isMobile() ? 30 : "auto" }}
                                >
                                    Filtrar
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container direction="column" padding={2} spacing={3}>
                        <Grid container size={{ xs: 12, sm: 12 }}>
                            <Grid size={{ xs: 12, sm: 12 }} >
                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20, }}>LISTA DE JOGADORES</Typography>
                                <hr />
                            </Grid>
                            <Grid margin={1} spacing={1} paddingBottom={1}>
                                {!removeLoading && <Loading />}
                            </Grid>
                            <Box sx={{
                                height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                '& .super-app-theme--header': {
                                    backgroundColor: theme.palette.common.black,
                                    color: theme.palette.common.white
                                },
                                '& .super-app.negative': {
                                    color: 'red',
                                    fontWeight: 'bold'
                                },
                                '& .super-app.positive': {
                                    color: themeName === "light" ? "black" : "auto",
                                },
                            }}>
                                <DataGrid
                                    localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                    getRowId={(rows) => rows.codigo_Jogador}
                                    rows={rowsJogadores}
                                    columns={columnsJogadores}
                                    columnVisibilityModel={{ codigo_Jogador: UtilidadeService.isMobile() ? false : true }}

                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                pageSize: 24,
                                                page: paginaJogadores - 1,
                                            },
                                        },
                                    }}
                                    //onRowClick={handleRedirect}
                                    pageSizeOptions={[24, 50, 100]}
                                    autoHeight
                                    slots={{ noRowsOverlay: MyCustomNoRowsOverlay }}
                                    sx={{
                                        fontSize: UtilidadeService.isMobile() ? 12 : 16,
                                    }}
                                    disableRowSelectionOnClick={UtilidadeService.isMobile() ? true : false}
                                    disableColumnFilter={UtilidadeService.isMobile() ? true : false}
                                    disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </VForm>
        </LayoutBaseDePagina >
    );
}